/* Podmiana ceny i dostępności przy zmianie rozmiaru. */
(function () {
  var sel = document.querySelector('[data-variants]');
  if (!sel) return;
  var price = document.querySelector('[data-price]');
  var stock = document.querySelector('[data-stock]');
  var add = document.querySelector('[data-add]');

  sel.addEventListener('change', function () {
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var available = opt.getAttribute('data-available') === 'true';
    if (price) price.textContent = opt.getAttribute('data-price') || '';
    if (stock) stock.textContent = available
      ? 'Dostępne: ' + opt.getAttribute('data-qty') + ' szt.'
      : 'Wyprzedane';
    if (add) {
      add.disabled = !available;
      add.textContent = available ? add.dataset.label || 'Dodaj do koszyka' : 'Wyprzedane';
    }
  });

  if (add) add.dataset.label = add.textContent.trim();
})();
